var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject } from 'mobx-react';
import { TaxCategory, TaxType } from '../Model';
import { rules } from 'helpers/Validation';
import { Form } from 'components';
import { FieldType } from 'elements';
import { loading } from 'elements/Loading';
import { t } from 'helpers/i18n';
var TaxForm = /** @class */ (function (_super) {
    __extends(TaxForm, _super);
    function TaxForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.taxCategory = Object.keys(TaxCategory).map(function (item, index, array) { return ({
            name: t(item),
            value: TaxCategory[item]
        }); });
        _this.taxType = Object.keys(TaxType).map(function (item) { return ({
            name: t(item),
            value: TaxType[item]
        }); });
        _this.fields = [
            {
                name: 'name',
                type: FieldType.Text,
                rules: rules()
                    .string()
                    .required(),
                size: 4
            },
            {
                name: 'type',
                type: FieldType.Select,
                rules: rules()
                    .string()
                    .required(),
                options: _this.taxType,
                size: 4
            },
            {
                name: 'value',
                type: FieldType.Text,
                rules: rules()
                    .number()
                    .required(),
                size: 4
            },
            {
                name: 'category',
                type: FieldType.Select,
                rules: rules().string().required(),
                options: _this.taxCategory,
                size: 4
            }
        ];
        return _this;
    }
    TaxForm.prototype.render = function () {
        var tax = this.props.tax;
        var taxes = this.props.store.taxes;
        console.log('tax: ', tax);
        return (React.createElement(Form, { loading: ['post@tax/', 'put@tax/'], fields: this.fields, values: tax, store: taxes }));
    };
    TaxForm = __decorate([
        inject('store'),
        loading(function (props) { return [
            props.match.params.id
                ? props.store.taxes.read(props.match.params.id).then(function (tax) { return ({ tax: tax }); })
                : undefined,
        ]; })
    ], TaxForm);
    return TaxForm;
}(Component));
export default TaxForm;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Taxes/container/TaxForm.tsx
// module id = 1252
// module chunks = 0